import {AmplitudeItemListName, IAmplitudeItemListContext} from "./get_amplitude_view_item_event_properties";

interface IAmplitudeItemListTrackingMeta {
    listId?: string | null;
    listName?: AmplitudeItemListName | null;
}

interface IGetAmplitudeItemListContextWithStaticFallbackParams {
    dynamicItemListContext?: IAmplitudeItemListContext | null;
    staticItemListContext?: IAmplitudeItemListContext | null;
    trackingMeta?: IAmplitudeItemListTrackingMeta | null;
    heading?: string | null;
}

export const getAmplitudeItemListContextWithStaticFallback = (
    params: IGetAmplitudeItemListContextWithStaticFallbackParams
): IAmplitudeItemListContext | null => {
    const {dynamicItemListContext, staticItemListContext, trackingMeta, heading} = params;

    if (dynamicItemListContext?.itemListId) {
        return dynamicItemListContext;
    }

    if (staticItemListContext?.itemListId) {
        return staticItemListContext;
    }

    const itemListName = trackingMeta?.listName ?? staticItemListContext?.itemListName ?? heading ?? undefined;
    const itemListId = trackingMeta?.listId ?? getStaticItemListIdFromName(itemListName);

    if (!itemListId) {
        return null;
    }

    return {
        itemListId,
        itemListName
    };
};

const getStaticItemListIdFromName = (itemListName?: AmplitudeItemListName): string | undefined => {
    if (typeof itemListName !== "string") {
        return undefined;
    }

    const normalizedItemListName = itemListName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[\u0141\u0142]/g, "l")
        .replace(/[\u00d8\u00f8]/g, "o")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");

    return normalizedItemListName || undefined;
};
import {AmplitudeItemListName, IAmplitudeItemListContext} from "./get_amplitude_view_item_event_properties";

interface IAmplitudeItemListTrackingMeta {
    listId?: string | null;
    listName?: AmplitudeItemListName | null;
}

interface IGetAmplitudeItemListContextWithStaticFallbackParams {
    dynamicItemListContext?: IAmplitudeItemListContext | null;
    staticItemListContext?: IAmplitudeItemListContext | null;
    trackingMeta?: IAmplitudeItemListTrackingMeta | null;
    heading?: string | null;
}

export const getAmplitudeItemListContextWithStaticFallback = (
    params: IGetAmplitudeItemListContextWithStaticFallbackParams
): IAmplitudeItemListContext | null => {
    const {dynamicItemListContext, staticItemListContext, trackingMeta, heading} = params;

    if (dynamicItemListContext?.itemListId) {
        return dynamicItemListContext;
    }

    if (staticItemListContext?.itemListId) {
        return staticItemListContext;
    }

    const itemListName = trackingMeta?.listName ?? staticItemListContext?.itemListName ?? heading ?? undefined;
    const itemListId = trackingMeta?.listId ?? getStaticItemListIdFromName(itemListName);

    if (!itemListId) {
        return null;
    }

    return {
        itemListId,
        itemListName
    };
};

const getStaticItemListIdFromName = (itemListName?: AmplitudeItemListName): string | undefined => {
    if (typeof itemListName !== "string") {
        return undefined;
    }

    const normalizedItemListName = itemListName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[\u0141\u0142]/g, "l")
        .replace(/[\u00d8\u00f8]/g, "o")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");

    return normalizedItemListName || undefined;
};
